import React, {Component} from 'react';
import Modal from "react-responsive-modal";
import {connect} from 'react-redux';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import {bindActionCreators} from 'redux';

import gal_icon from "../../../assets/images/gal_icon.png";
import tag_icon from "../../../assets/images/tag_icon.png";
import sm_icon from "../../../assets/images/sm_icon.png";


import {createPostRequest, getUserFriendlist} from "../../../actions/feedAction";
import { loader } from '../../../actions/utils';
import './PostCreate.css';
import PostImage from './PostImage';
import { cloudinaryAlbumUploader } from './../../../helpers/cloudinaryFileUploader';
import iconPath from "./../../../helpers/iconHelper";
import SimplePopover from "./friendlist";
import $ from "jquery";
import { getlanguagelist } from "../../../helpers/changelanguage";

const customStyles = {
  width: '556px',
  position: 'relative'
};

class PostCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open              : false,
      isLoading         : false,
      post_content      : '',
      media_files       : [],
      raw_file          : [],
      shouldHide        : 'hidden',
      raw_file_to       : [],
      openpopTag        :  'none',
      openpopDedicate   :  'none',
      tagged_user       : [],
      dedicated_user    : [],
      friend_pagination : 0,
      friend_search     : '',
      friendList        : []
    };
 
    this.onSubmit     = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onOpenModal  = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.fileUpload   = this.fileUpload.bind(this);
    this.changeFile   = this.changeFile.bind(this);
    this.formSubmit   = this.formSubmit.bind(this);
    this.romoveImage  = this.romoveImage.bind(this);
    this.openTag      = this.openTag.bind(this);
    this.openDedicate = this.openDedicate.bind(this);
    this.doTag        = this.doTag.bind(this);
    this.doDedicate   = this.doDedicate.bind(this);
    this.emitChange   = this.emitChange.bind(this);
    this.fetchFriend  = this.fetchFriend.bind(this);
    this.onScroll     = this.onScroll.bind(this);
    this.onSearch     = this.onSearch.bind(this);  
    this.check        = this.check.bind(this); 
    this.preview      = this.preview.bind(this);
  }
  openTag(){
    this.setState({
      openpopTag : this.state.openpopTag == 'block' ? 'none' : 'block' 
    });
  }
  openDedicate(){
    this.setState({
      openpopDedicate : this.state.openpopDedicate == 'block' ? 'none' : 'block' 
    });
  }
  
  onOpenModal() {
    $('.write_post').blur();
    this.setState({open: true});
  };

  onCloseModal() {
    
    this.setState({ open         : false,
                    post_content : '',
                    media_files  : [],
                    raw_file     : [],
                    shouldHide   : 'hidden',
                    openpopTag   :  'none',
                    openpopDedicate :  'none',
                    tagged_user     : [],
                    dedicated_user  : []
                });
  };
 
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  emitChange(){
    this.setState({ post_content: $('#post_content').html()});
  }

  doDedicate(user,username){
   
    let checkedDedicate = this.state.dedicated_user;
    if(document.getElementById(`user_dedicate_${user}`).checked == true){
      checkedDedicate.push(user);
      this.setState({
        dedicated_user : checkedDedicate,
        post_content   : (this.state.post_content == '') ? `<a href='${user}'>@${username}</a>` : `${this.state.post_content} <a href='${user}'>@${username}</a>`,
        openpopDedicate: 'none'
      });
    }else{
      checkedDedicate.pop(user);
      this.setState({
        dedicated_user : checkedDedicate,
        post_content   : this.state.post_content.replace(`<a href='${user}'>@${username}</a>`,''),
        openpopDedicate: 'none'
      });
    }
  }
  doTag(user,username){
    let checkedtag = this.state.tagged_user;
    if(document.getElementById(`user_tag_${user}`).checked == true){
      checkedtag.push(user);
      this.setState({
        tagged_user  : checkedtag,
        post_content : `${this.state.post_content} <a href='${user}'>@${username}</a>`,
        openpopTag   : 'none'
       
      });
    }else{
      checkedtag.pop(user);
      this.setState({
        tagged_user  : checkedtag,
        post_content : this.state.post_content.replace(`<a href='${user}'>@${username}</a>`,''),
        openpopTag   : 'none'
       
      });
    }
  }


  romoveImage(e){
    let rawFile = this.state.raw_file;
    rawFile.splice(e, 1);

    let mediaFiles = this.state.media_files;
    mediaFiles.splice(e, 1);

    let rawFileTo = this.state.raw_file_to;
    rawFileTo.splice(e, 1);
   
    this.setState({raw_file    : rawFile,
                   media_files : mediaFiles,
                   raw_file_to : rawFileTo
                  });
  };
  changeFile2(e){
    let total_file_arr = e.target.files;
    this.setState({raw_file_to : Array.from(e.target.files)});
    let create_preview = [];
    for (let i = 0; i < (total_file_arr.length); i++) { 
      let file = e.target.files[i];
      let reader = new FileReader();
      let url    = reader.readAsDataURL(file);
      reader.onloadend = function () {
        create_preview.push(reader.result);
        this.setState({
          shouldHide : '',
          raw_file   : [...create_preview]
        });
      }.bind(this);
    }
       
  }
  changeFile(e){
    let create_preview = this.state.raw_file;
    let  languagelist = getlanguagelist();
    let total_file_arr = e.target.files;
    this.setState({raw_file_to : Array.from(e.target.files)});
   
    for (let i = 0; i < (total_file_arr.length); i++) { 
      let file = e.target.files[i];

        if(file.type.includes("image")){
            let reader = new FileReader();
            let url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
              create_preview.push(reader.result);
              this.setState({
                shouldHide : '',
                raw_file   : create_preview
              });
            }.bind(this);
        }else{

            var video = document.createElement('video');
            video.preload = 'metadata';
            var obj = this;
            video.onloadedmetadata = function() {
              window.URL.revokeObjectURL(video.src);
              if (video.duration > 120) {
                ToastsStore.error(languagelist.validvedio);
                return;
              }
              obj.preview(file);
            }
             video.src = URL.createObjectURL(file);
          }
    }
       
  }

  preview(file){
    let create_preview = this.state.raw_file;
      let reader = new FileReader();
      let url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        create_preview.push(reader.result);
        this.setState({
          shouldHide : '',
          raw_file   : create_preview
        });
      }.bind(this);
  }

  componentDidMount(){
    this.romoveImage();
    this.fetchFriend();
  }

  fetchFriend(){
    this.props.getUserFriendlist(this.state);
  }
  onScroll(){
    this.setState({
      friend_pagination : this.state.friend_pagination + 1
    },function(){
      this.fetchFriend();
    });
  }
  onSearch(friend_search){
    this.setState({
      friend_search     : friend_search,
      friend_pagination : 0
    },function(){
      if(friend_search.length >= 3){
        this.fetchFriend();
      } 
      if(friend_search == ''){
        this.fetchFriend();
      }
    });
  }

  onSubmit(e){
    e.preventDefault();
    if(this.state.raw_file.length > 0){
      this.fileUpload(this.state.raw_file);  
    }else{
      this.setState({isLoading: true})
      this.formSubmit();
    }
  };

  formSubmit(){
   
    const isValid = true; 
    if (isValid){
      this.props.createPostRequest(this.state);
    }else{
      ToastsStore.error(error.message)
      this.setState({isLoading  : false});
    } 
  }
  fileUpload(file){
    this.setState({isLoading: true});
    loader(true);
    let new_res = [];
    let uploadResponse  = [];
    let uploadPathImage = `uploads/${this.props.currentUserDetails.user.id}/upload_image_path`;
    let uploadPathVideo = `uploads/${this.props.currentUserDetails.user.id}/upload_video_path`;
    uploadResponse      = cloudinaryAlbumUploader(file,uploadPathImage,uploadPathVideo);
    uploadResponse.then((response)=>{
      response.map(res => {
        new_res.push({'media_type':(res.data.resource_type == 'video') ? 'VIDEO' : 'IMAGE','media_link':`${res.data.public_id}.${res.data.format}`,'media_website':''});
      })
      this.setState({
        media_files: new_res
      });
      this.formSubmit();
    }); 
  } 

  check(e){

    let key       = (e.keyCode);
    let tagged    = this.state.tagged_user || [];
    let dedicated = this.state.dedicated_user || [];
   
    if( key == 8 || key == 46 ){
      let text      = $('#post_content').html();
      tagged.map(tag => {
        if(text.includes("<a href='"+tag+"'>") == false){
         tagged.splice(tagged.indexOf(tag), 1 );
         document.getElementById("user_tag_"+tag).checked = false;
        }
      })

      
      dedicated.map(dedi => {
        if(text.includes("<a href='"+dedi+"'>") == false){
          dedicated.splice(dedicated.indexOf(dedi), 1 );
          document.getElementById("user_dedicate_"+dedi).checked = false;
        }
      }) 
      this.setState({
        tagged_user     : tagged,
        dedicated_user  : dedicated
      });
    }
  }
  
 
  componentDidUpdate() {
    //console.log(this.props.lastCreatedPost.post_id);
  }
  

  UNSAFE_componentWillReceiveProps(nextProps) {
    
    if(nextProps.lastCreatedPost != this.props.lastCreatedPost){
      ToastsStore.success('Post created successfully');
      
      this.setState({
        isLoading       : nextProps.lastCreatedPost.isLoading,
        post_content    : '',
        open            : false,
        media_files     : [],
        raw_file        : [],
        shouldHide      : 'hidden',
        openpopTag      : 'none',
        openpopDedicate : 'none',
        tagged_user     : [],
        dedicated_user  : []
      })
      setTimeout(() => {
        this.onCloseModal();
      }, 6000);
    }
      let friendList = this.state.friendList;
     
      if(nextProps.userfriendlist != this.props.userfriendlist){
        if (this.state.friend_pagination == 0) {
          friendList =  [...nextProps.userfriendlist];
        }else if(this.state.friend_search != ''){
          friendList =  [...nextProps.userfriendlist];
        }else{
          let nextfriendList = nextProps.userfriendlist;
          
          if(nextfriendList !== this.props.userfriendlist){
            Object.keys(nextfriendList).map((key) => {
              friendList.push(nextfriendList[key]);
            });
          }
        }
        this.setState({
          friendList : friendList
        });
      }
  }


  render() {
    let  languagelist = getlanguagelist();
    return (
      <div>
        <div className="post_box">
          <div className="center_post border-post">
            <div className="post_header">
              <div className="list_ico">
              {
                  (this.props.currentUserDetails.user.image != '') ? 
                  <img  className={(this.props.currentUserDetails.user.membership == 'GOLD') ? "gold_user" : ""} src={this.props.currentUserDetails.user.image} onError = {(e) => {
                    e.target.src = iconPath['DEFAULTUSER']
                  }}/> : 
                  <img src={iconPath['DEFAULTUSER']}/>
              }
              </div>
              <div className="list_details">
                <textarea
                  className="write_post"
                  onClick={this.onOpenModal}
                  placeholder={languagelist.whatsonyourmind}
                />
              </div>
            </div>
          </div>
          <div className="post_footer">
             <ul className="newpost_footer">
              <li>
                <a ><img src={gal_icon}/></a>
              </li>
              <li>
                <a ><img src={tag_icon}/></a>
              </li>
              <li>
                <a ><img src={sm_icon}/></a>
              </li>
            </ul>
          </div>
        
        </div>
       
        <Modal open={this.state.open} onClose={this.onCloseModal} showCloseIcon={false} center>
          
          <form id="createpost-form" onSubmit={this.onSubmit}>
            <div className="modal-header2">
            <button type="button" className="close" onClick={this.onCloseModal} ><img src="/assets/images/close_btn.png"/></button>
              {
                  (this.props.currentUserDetails.user.image != '') ? 
                  <img className={(this.props.currentUserDetails.user.membership == 'GOLD') ? "post_user gold_user" : "post_user"} src={this.props.currentUserDetails.user.image} onError = {(e) => {
                    e.target.src = iconPath['DEFAULTUSER'] 
                  }}/> : 
                  <img className="post_user" src={iconPath['DEFAULTUSER']}/>
              }
              
              <h4 className="modal-title">{this.props.currentUserDetails.user.full_name}</h4>
            </div>
            <div className="modal-body" style={customStyles}>
            
           
              
                <div contentEditable="true" 
                className="modal-textarea"
                placeholder={languagelist.whatsonyourmind}
                name="post_content"
                id="post_content"
                dangerouslySetInnerHTML={{__html: this.state.post_content}}
                onBlur={()=>this.emitChange(this)}
                required 
                onKeyDown={this.check}
               />
                <div id="imageSection"  className={this.state.shouldHide}>
                   {/*  <img src={this.state.raw_file}/> */}
                   <PostImage images={this.state.raw_file} romoveImage={this.romoveImage}/>
                </div>
              <ul className="attach_list">
                {/* <li>
                  <a href="#">
                    <img src="/assets/images/post_smile.png" />
                 
                  </a>
                </li>
                <li>
               
                  <img src="/assets/images/post_gif.png" />
                </li>
                <li>
                  <a href="#">
                    <img src="/assets/images/post_pin.png" />
                  
                  </a>
                </li>
                <li>
                  <a href="#">
                     <img src="/assets/images/post_cam.png" />
                   
                  </a>
                </li> */}
                <li className="tag_icon">
                  <a href={void(0)} onClick={this.openTag} title="tag">
                    {/* <i className="fa fa-tag" aria-hidden="true"></i> */}
                    <img src="/assets/images/post_tag.png" />
                  </a>
                  <SimplePopover 
                  openpop={this.state.openpopTag} 
                  userfriendlist={this.state.friendList} 
                  doChange={this.doTag} 
                  checkedUser={this.state.tagged_user}
                  type="tag" 
                  onScroll = {this.onScroll}
                  onSearch = {this.onSearch}
                  />

                </li>
                <li className="tag_icon">
                  <a href={void(0)} onClick={this.openDedicate} title="dedicate">
                  {/*  <i className="fa fa-heart" aria-hidden="true"></i> */}
                   <img src="/assets/images/post_love.png" />
                  </a>
                  <SimplePopover 
                    openpop={this.state.openpopDedicate} 
                    userfriendlist={this.state.friendList} 
                    doChange={this.doDedicate} 
                    checkedUser={this.state.dedicated_user} 
                    type="dedicate" 
                    onScroll = {this.onScroll} 
                    onSearch = {this.onSearch}
                    />
                </li>
                <li>
                  <a href="#" className="brows_btn" title="image/video">
                   {/*  <i className="fa fa-picture-o" aria-hidden="true"></i> */}
                     <img src="/assets/images/post_gallery.png" />
                    <input className="brows_file" type="file" onChange={this.changeFile} multiple accept="image/*,video/*"/>
                  </a>
                </li>
               {/*  <li>
                  <a href="#">
                    <img src="/assets/images/post_audio.png" />
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="modal-footer">
              <input type="submit" className="btn_5" value={languagelist.post}/>
            </div>
            
          </form>

        </Modal>
        
      </div>
    );
  }

}

const mapStateToProps = state => {
  
  return {currentUserDetails: state.login, 
          lastCreatedPost   : state.lastpost,
          userfriendlist    : state.postfriend.postFriend.friend_details
         }
}

const mapDispatchToProps = dispatch => {
  return {
    createPostRequest : bindActionCreators(createPostRequest, dispatch),
    getUserFriendlist : bindActionCreators(getUserFriendlist, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostCreate);